import XRSlide from './slide.vue';

export default XRSlide


// WEBPACK FOOTER //
// ./src/components/swiper/slideindex.js